export default __webpack_public_path__ + "a4d2e04e48f4a281a5dcf48e3196e364.svg";